import { useEffect, useState } from "react";
import { fetchClassCertificateTypes, fetchTenantInstructorIds } from "../../api/apiClient";

/**
 * For instructor pickers on a class: whether the class issues AHA eCards, and whether an instructor has an AHA
 * instructor ID in this center (only those can teach an AHA class). The server enforces the same rule; this lets
 * the picker say so before anyone tries. Fails open (nothing is marked) if either lookup is unavailable.
 */
export default function useAhaTeachingCheck(classId) {
  const [state, setState] = useState({ ahaClass: false, withId: new Set() });

  useEffect(() => {
    if (!classId) return undefined;
    let active = true;
    fetchClassCertificateTypes(classId)
      .then((selection) => {
        if (!(selection?.types || []).includes("AHA")) return { ahaClass: false, withId: new Set() };
        return fetchTenantInstructorIds().then((ids) => ({
          ahaClass: true,
          withId: new Set(Object.keys(ids?.ids?.AHA_INSTRUCTOR || {})),
        }));
      })
      .then((next) => { if (active) setState(next); })
      .catch(() => { if (active) setState({ ahaClass: false, withId: new Set() }); });
    return () => { active = false; };
  }, [classId]);

  return {
    ahaClass: state.ahaClass,
    /** True when this instructor can't be assigned: the class issues AHA and they have no AHA ID here. */
    blocked: (userId) => state.ahaClass && userId != null && !state.withId.has(String(userId)),
  };
}
